import { WidgetType } from '@/models/Enums';
import { ILoadProducts } from '@/models/Parameters';

export default class Api {
  private static projectPart(): string {
    return (window as any).dkVars.isDe ? 'de' : 'dk';
  }
  public static getProducts(params: ILoadProducts): Promise<Response> {
    return Api.request(params.id, params.type, 'GetByPk', params.extra);
  }
  public static getLiteShops(extra?: string): Promise<Response> {
    return Api.request('', WidgetType.LocalShop, 'GetLite', extra);
  }

  public static async GeoComplete(query: string): Promise<string[]> {
    const fetching = await fetch(new Request(`${Api.server}/SearchCompleter/${query}`));
    return fetching.json();
  }
  private static server = ((window as any).dkVars.ApiServer as string) || 'https://api-test.medianord.de';
  private static async request(id: string, type: WidgetType, endpoint: string, extra?: string): Promise<any> {
    let myRequest: Request;
    switch (type) {
      case WidgetType.Cameras:
        // myRequest = new Request(`https://localhost:44305/api/cameraDatasheetWidget`);
        myRequest = new Request(`/api/cameraDatasheetWidget`);
        break;
      default:
        myRequest = new Request(`${Api.server}/${Api.projectPart()}/${type}/${endpoint}/${id}${extra ? extra : ''}`);
        break;
    }
    const fetching = await fetch(myRequest);
    if (fetching.status >= 400) {
      throw new Error(`${type}-${endpoint}-${id} ${fetching.status}: ${fetching.statusText}`);
    }
    return fetching;
  }
}
